import React from "react";
// import { Switch } from "react-router-dom";
import BasePage from "./BasePage";

 export default function Routes() {
    return (
            <BasePage />
    );
}
